<template>
    <div class="container">
        <div class="content">
            <div class="input-box">
                <img src="./image/input-bg.png">
                <!-- 留言文本域 -->
                <label class="textarea" for="message" v-show="currentBtnId === 1">
                    <textarea id="message" name="message" maxlength="20" v-model="message"></textarea>
                </label>
                <!-- 上传图片显示区 -->
                <div class="upload-image" v-show="currentBtnId === 2">
                    <img :src="uploadImage">
                </div>
                <!-- 特效图片显示区 -->
                <div class="effects-image" v-show="currentBtnId === 3">
                    <img :src="effectsImage">
                </div>
            </div>
            <div class="upload-box">
                <img src="./image/upload.png" v-show="!uploading" @click="uploadInformation">
                <div class="loader" v-show="uploading === true"></div>
                <div v-show="uploading === 2" style="color: white;">上传完成</div>
            </div>
            <div class="btns-box">
                <div class="btn" v-for="btn in btnList" :key="btn.id" @click="changeBtn(btn)">
                    <img :src="btn.defaultImage" v-show="!btn.show">
                    <img :src="btn.selectedImage" v-show="btn.show">
                </div>
            </div>
            <div class="message-box" v-show="currentBtnId === 1">
                <div class="message" v-for="message in messageList" :key="message.id"
                    :style="{ 'opacity': message.show ? '1' : '0.3' }" @click="changeMessage(message)">
                    <img :src="message.image">
                </div>
            </div>
        </div>
        <!-- 特效列表容器 -->
        <div class="effects-content" v-show="effectsShow">
            <div class="effects" v-for="effects in effectsList" :key="effects.effectsNo"
                @click="selectEffects(effects)">
                <img :src="effects.effectsImage">
                <div>{{ effects.title }}</div>
                <div class="separator" v-show="effects.separatorShow"></div>
            </div>
        </div>
        <div>
            <audio ref="bgm" :src="audioObj.bgm" loop></audio>
            <audio ref="keysound" :src="audioObj.keysound"></audio>
            <audio ref="send" :src="audioObj.send"></audio>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import imageCompression from 'browser-image-compression';
import Axios from "axios";
export default {
    data() {
        return {
            screenId: undefined,
            // 按钮列表
            btnList: [
                {
                    id: 1,
                    show: true,
                    defaultImage: require('./image/message-default.png'),
                    selectedImage: require('./image/message-selected.png'),
                },
                {
                    id: 2,
                    show: false,
                    defaultImage: require('./image/photo-default.png'),
                    selectedImage: require('./image/photo-selected.png'),
                },
                {
                    id: 3,
                    show: false,
                    defaultImage: require('./image/effects-default.png'),
                    selectedImage: require('./image/effects-selected.png'),
                }
            ],
            // 消息框列表
            messageList: [
                {
                    id: 1,
                    image: require('./image/message-1.png'),
                    show: true
                },
                {
                    id: 2,
                    image: require('./image/message-2.png'),
                    show: false
                },
                {
                    id: 3,
                    image: require('./image/message-3.png'),
                    show: false
                }
            ],
            // 特效资源表
            effectsList: [
                {
                    effectsNo: 1,
                    effectsImage: require('./image/effects-1.png'),
                    title: '花炮',
                    separatorShow: true
                },
                {
                    effectsNo: 2,
                    effectsImage: require('./image/effects-2.png'),
                    title: '喇叭花',
                    separatorShow: true
                },
                {
                    effectsNo: 3,
                    effectsImage: require('./image/effects-3.png'),
                    title: '礼盒',
                    separatorShow: false
                },
                {
                    effectsNo: 4,
                    effectsImage: require('./image/effects-4.png'),
                    title: '孔明灯',
                    separatorShow: true
                },
                {
                    effectsNo: 5,
                    effectsImage: require('./image/effects-5.png'),
                    title: '气球',
                    separatorShow: true
                },
                {
                    effectsNo: 6,
                    effectsImage: require('./image/effects-6.png'),
                    title: '气球礼盒',
                    separatorShow: false
                },
                {
                    effectsNo: 7,
                    effectsImage: require('./image/effects-7.png'),
                    title: '烟花-1',
                    separatorShow: true
                },
                {
                    effectsNo: 8,
                    effectsImage: require('./image/effects-8.png'),
                    title: '烟花-2',
                    separatorShow: true
                },
                {
                    effectsNo: 9,
                    effectsImage: require('./image/effects-9.png'),
                    title: '烟花-3',
                    separatorShow: false
                },
                {
                    effectsNo: 10,
                    effectsImage: require('./image/effects-10.png'),
                    title: '福到',
                    separatorShow: true
                },
                {
                    effectsNo: 11,
                    effectsImage: require('./image/effects-11.png'),
                    title: '红包',
                    separatorShow: true
                },
                {
                    effectsNo: 12,
                    effectsImage: require('./image/effects-12.png'),
                    title: '爱心',
                    separatorShow: false
                },
                {
                    effectsNo: 13,
                    effectsImage: require('./image/effects-13.png'),
                    title: '星星',
                    separatorShow: true
                },
                {
                    effectsNo: 14,
                    effectsImage: require('./image/effects-14.png'),
                    title: '魔法棒',
                    separatorShow: true
                },
                {
                    effectsNo: 15,
                    effectsImage: require('./image/effects-15.png'),
                    title: '仙女棒',
                    separatorShow: false
                },
                {
                    effectsNo: 16,
                    effectsImage: require('./image/effects-16.png'),
                    title: 'Nice',
                    separatorShow: true
                },
                {
                    effectsNo: 17,
                    effectsImage: require('./image/effects-17.png'),
                    title: '摇啊摇',
                    separatorShow: true
                },
                {
                    effectsNo: 18,
                    effectsImage: require('./image/effects-18.png'),
                    title: '撒花',
                    separatorShow: false
                },
                {
                    effectsNo: 19,
                    effectsImage: require('./image/effects-19.png'),
                    title: '可爱',
                    separatorShow: true
                },
                {
                    effectsNo: 20,
                    effectsImage: require('./image/effects-20.png'),
                    title: 'L|｀О’|┘ 嗷~~',
                    separatorShow: true
                },
                {
                    effectsNo: 21,
                    effectsImage: require('./image/effects-21.png'),
                    title: '干杯',
                    separatorShow: false
                },
            ],
            // 上传中
            uploading: false,
            // 当前按钮id
            currentBtnId: 1,
            // 当前留言框id
            currentMessageId: 1,
            // 留言内容
            message: '',
            // 上传图片
            uploadImage: '',
            // 特效图片
            effectsNo: 0,
            effectsImage: '',
            effectsShow: false,

            audioObj: {
                bgm: require('./audio/bgm.mp3'),
                keysound: require('./audio/keysound.mp3'),
                send: require('./audio/send.mp3'),
            },
        }
    },
    mounted() {
        this.screenId = parseInt(this.$route.query.s)
        document.addEventListener('click', ()=>{
            //this.$refs.bgm.play().catch(error => {});
        });
    },
    methods: {
        // 切换按钮
        changeBtn(btn) {
            this.$refs.keysound.currentTime = 0;
            this.$refs.keysound.play().catch(error => {});

            let repeatedClickFlag = btn.id === this.currentBtnId
            if (!repeatedClickFlag) {
                this.message = ''
                this.uploadImage = ''
                this.effectsNo = 0
                this.effectsImage = ''
            }
            this.btnList.forEach(b => {
                b.show = false
            })
            btn.show = true
            this.currentBtnId = btn.id
            if (btn.id === 2) {
                // 点击图片
                // 打开相册选择图片
                // 动态创建input元素
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = 'image/*'; // 限制只能选择图片

                input.onchange = async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    // 检查文件类型是否为图片
                    if (!file.type.match('image.*')) {
                        alert('请选择图片文件');
                        return;
                    }
                    // 压缩图片
                    const options = {
                        maxSizeMB: 1,          // 压缩后最大文件大小（MB）
                        maxWidthOrHeight: 640, // 短边限制为 640px
                        useWebWorker: true,    // 启用 Web Worker 加速
                        fileType: file.type,   // 保持原格式
                    };
                    try {
                        // 压缩图片
                        let newFile = await imageCompression(file, options);
                        // 使用FileReader读取图片并预览
                        const reader = new FileReader();
                        reader.onload = (event) => {
                            this.uploadImage = event.target.result; // Base64数据
                        };
                        reader.readAsDataURL(newFile); // 转换为Base64
                    } catch (error) {
                        console.error('压缩失败:', error);
                    }
                };
                input.click(); // 触发文件选择
            }
            if (btn.id === 3) {
                this.effectsShow = true
            } else {
                this.effectsShow = false
            }
        },
        // 切换留言框
        changeMessage(message) {
            //this.$refs.keysound.play().catch(error => {});

            this.messageList.forEach(m => {
                m.show = false
            })
            message.show = true
            this.currentMessageId = message.id
        },
        // 选择特效
        selectEffects(effects) {
            //this.$refs.keysound.play().catch(error => {});

            this.effectsNo = effects.effectsNo
            this.effectsImage = effects.effectsImage
            this.effectsShow = false
        },
        // 上传
        uploadInformation() {
            // this.$refs.keysound.play().catch(error => {});

            this.uploading = true
            if (this.currentBtnId === 1) {
                // 留言
                if (this.message.trim()) {
                    const information = {
                        screenId: this.screenId,
                        materialId: this.currentBtnId,
                        messageContent: this.message.trim(),
                        messageBackgroundId: this.currentMessageId
                    }
                    this.sendInformation(information)
                } else {
                    alert("还未输入留言！")
                    this.uploading = false
                }
            }
            if (this.currentBtnId === 2) {
                // 图片
                if (this.uploadImage) {
                    const information = {
                        screenId: this.screenId,
                        materialId: this.currentBtnId,
                        imageBase: this.uploadImage
                    }
                    this.sendInformation(information)
                } else {
                    alert("还未添加图片！")
                    this.uploading = false
                }
            }
            if (this.currentBtnId === 3) {
                // 特效
                if (this.effectsImage) {
                    const information = {
                        screenId: this.screenId,
                        materialId: this.currentBtnId,
                        effectsNumber: this.effectsNo
                    }
                    this.sendInformation(information)
                } else {
                    alert("还未选择特效！")
                    this.uploading = false
                }
            }
        },
        sendInformation(information) {
            Axios.post(process.env.VUE_APP_BASE_API + '/upload', information).then(req => {
                if (req.data.code === 200) {
                    this.uploading = 2;
                    this.$refs.send.play().catch(error => {});
                    this.$refs.send.onended = () => {
                        window.location.reload();
                    }
                }
                if (req.data.code === 400) {
                    alert(req.data.msg)
                    this.uploading = false
                }
            })
        }
        // getImageDimensions(file) {
        //     return new Promise((resolve, reject) => {
        //         const img = new Image();
        //         img.onload = () => {
        //             URL.revokeObjectURL(img.src); // 释放内存
        //             resolve({
        //                 width: img.naturalWidth,  // 原始宽度
        //                 height: img.naturalHeight // 原始高度
        //             });
        //         };
        //         img.onerror = reject;
        //         img.src = URL.createObjectURL(file); // 生成临时 URL
        //     });
        // }
    },
}
</script>

<style scoped>
.container {
    width: 100%;
    height: 100vh;
    background-image: url('./image//bg.png');
    background-size: 100% 100%;
}

img {
    width: 100%;
    vertical-align: bottom;
}

.content {
    width: 72%;
    position: absolute;
    left: 50%;
    top: 5%;
    transform: translate(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.input-box {
    width: 100%;
    margin-bottom: 10%;
    position: relative;
}

.textarea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

textarea {
    width: 95%;
    background-color: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 20px;
}

.upload-image,
.effects-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.upload-image img,
.effects-image img {
    max-width: 95%;
    max-height: 95%;
    object-fit: contain;
}

.upload-box {
    width: 32%;
    margin-bottom: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 88 / 34;
}

.btns-box {
    width: 100%;
    margin-bottom: 10%;
    display: flex;
    justify-content: space-between;
}

.btn {
    width: 30%;
}

.message-box {
    position: absolute;
    left: 50%;
    bottom: -20%;
    transform: translate(-50%);
    display: flex;
    justify-content: space-between;
    width: 120%;
}

.message {
    width: 30%;
}

.effects-content {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50vh;
    background-color: #2c3138;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    overflow-y: auto;  
}

.effects {
    width: 33.33%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    position: relative;
    margin: 3.5% 0;
}

.effects img {
    width: 60%;
}

.separator {
    position: absolute;
    right: 0;
    top: 50%;
    width: 1%;
    height: 25%;
    transform: translateY(-50%);
    background-color: #626a75;
}

.loader {
    width: 25px;
    padding: 4px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #25b09b;
    --_m:
        conic-gradient(#0000 10%, #000),
        linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
    mask: var(--_m);
    -webkit-mask-composite: source-out;
    mask-composite: subtract;
    animation: l3 1s infinite linear;
}

@keyframes l3 {
    to {
        transform: rotate(1turn)
    }
}
</style>